import { render, staticRenderFns } from "./UpdateInfo.vue?vue&type=template&id=01a7b4a2&"
import script from "./UpdateInfo.vue?vue&type=script&lang=js&"
export * from "./UpdateInfo.vue?vue&type=script&lang=js&"
import style0 from "./UpdateInfo.vue?vue&type=style&index=0&id=01a7b4a2&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01a7b4a2')) {
      api.createRecord('01a7b4a2', component.options)
    } else {
      api.reload('01a7b4a2', component.options)
    }
    module.hot.accept("./UpdateInfo.vue?vue&type=template&id=01a7b4a2&", function () {
      api.rerender('01a7b4a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorServicePrices/components/UpdateInfo/UpdateInfo.vue"
export default component.exports